import React, { useState } from 'react';
import { CalendarIcon, UsersIcon, LineChartIcon, CheckCircleIcon, ExternalLinkIcon, ChevronRightIcon, ChevronDownIcon, ClockIcon, MapPinIcon, BriefcaseIcon, FileTextIcon, PlusIcon, XIcon, MailIcon, TrendingUpIcon, AlertTriangleIcon, BuildingIcon, GlobeIcon, PhoneIcon, BarChart3Icon, PieChartIcon, CircleDollarSignIcon, BrainIcon, HeartHandshakeIcon, StarIcon } from 'lucide-react';
export function GooglePlugin() {
  const [expanded, setExpanded] = useState<string[]>(['ai-pov', 'meeting-info', 'attendees']);
  const [expandedContacts, setExpandedContacts] = useState<string[]>([]);
  const toggleSection = (section: string) => {
    if (expanded.includes(section)) {
      setExpanded(expanded.filter(s => s !== section));
    } else {
      setExpanded([...expanded, section]);
    }
  };
  const toggleContact = (contactId: string) => {
    if (expandedContacts.includes(contactId)) {
      setExpandedContacts(expandedContacts.filter(id => id !== contactId));
    } else {
      setExpandedContacts([...expandedContacts, contactId]);
    }
  };
  const attendees = [{
    id: 'tr1',
    name: 'Teena Reale',
    role: 'VP of Product',
    company: 'Nexus Technologies',
    status: 'Going',
    researched: true,
    email: 'teena.reale@nexustech.com',
    phone: '+1 (415) 555-7821',
    linkedin: 'linkedin.com/in/teenareale',
    bio: 'Product leader with 10+ years experience in SaaS platforms. Previously led product at Salesforce.',
    notes: 'Key decision maker for software integrations. Interested in automation and AI solutions.'
  }, {
    id: 'el2',
    name: 'Edwin Lee',
    role: 'Senior Product Manager',
    company: 'Nexus Technologies',
    status: 'Going',
    researched: true,
    email: 'edwin.lee@nexustech.com',
    phone: '+1 (415) 555-3492',
    linkedin: 'linkedin.com/in/edwinlee',
    bio: 'Focused on enterprise solutions and API integrations. Background in software engineering.',
    notes: 'Technical product manager who will evaluate integration capabilities. Prefers data-driven discussions.'
  }, {
    id: 'bb3',
    name: 'Brad Blackwell',
    role: 'Sales Director',
    company: 'Nexus Technologies',
    status: 'Going',
    researched: true,
    email: 'brad.blackwell@nexustech.com',
    phone: '+1 (415) 555-9087',
    linkedin: 'linkedin.com/in/bradblackwell',
    bio: 'Leads enterprise sales team with focus on financial services and healthcare verticals.',
    notes: 'Looking for solutions to help close more deals. Concerned about implementation timeline.'
  }, {
    id: 'la4',
    name: 'Laura Asciak',
    role: 'Marketing Lead',
    company: 'Nexus Technologies',
    status: 'Going',
    researched: false,
    email: 'laura.asciak@nexustech.com',
    linkedin: 'linkedin.com/in/lauraasciak'
  }, {
    id: 'sk5',
    name: 'Simon Kershaw',
    role: 'Engineering Lead',
    company: 'Nexus Technologies',
    status: 'Going',
    researched: false,
    email: 'simon.kershaw@nexustech.com',
    linkedin: 'linkedin.com/in/simonkershaw'
  }, {
    id: 'al6',
    name: 'Amaya Losa',
    role: 'UX Designer',
    company: 'Nexus Technologies',
    status: 'Not Going',
    researched: false,
    email: 'amaya.losa@nexustech.com',
    linkedin: 'linkedin.com/in/amayalosa'
  }, {
    id: 'ev7',
    name: 'Elle Vernerey',
    role: 'QA Engineer',
    company: 'Nexus Technologies',
    status: 'Maybe',
    researched: false,
    email: 'elle.vernerey@nexustech.com',
    linkedin: 'linkedin.com/in/ellevernerey'
  }, {
    id: 'dg8',
    name: 'David Gallirihir',
    role: 'Stakeholder',
    company: 'Nexus Technologies',
    status: 'Awaiting',
    researched: false,
    email: 'david.gallirihir@nexustech.com',
    linkedin: 'linkedin.com/in/davidgallirihir'
  }, {
    id: 'jm9',
    name: 'Joshua Mac Guinness',
    role: 'Stakeholder',
    company: 'Nexus Technologies',
    status: 'Awaiting',
    researched: false,
    email: 'joshua.macguinness@nexustech.com',
    linkedin: 'linkedin.com/in/joshuamacguinness'
  }, {
    id: 'mc10',
    name: 'Michael Clutterbuck',
    role: 'CTO',
    company: 'Nexus Technologies',
    status: 'Awaiting',
    researched: false,
    email: 'michael.clutterbuck@nexustech.com',
    linkedin: 'linkedin.com/in/michaelclutterbuck'
  }];
  return <div className="w-full h-full bg-white text-gray-800 font-sans flex flex-col overflow-hidden" data-id="element-2156">
      {/* Header */}
      <div className="flex items-center justify-between p-3 border-b border-gray-200" data-id="element-2157">
        <div className="flex items-center" data-id="element-2158">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ov4W5y1TwYUNeHUCdRzqBe/Prepz.io_Logo_2.png" alt="Prepz.io Logo" className="h-16 w-auto" data-id="element-2159" />
          <span className="ml-1 text-sm font-semibold text-gray-800" data-id="element-2160">
            Prepz.io
          </span>
        </div>
        <div className="flex" data-id="element-2161">
          <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-2162">
            <XIcon className="h-4 w-4 text-gray-500" data-id="element-2163" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto" data-id="element-2164">
        <div className="p-3 space-y-3" data-id="element-2165">
          {/* AI POV Section */}
          <div className="mb-3" data-id="element-2166">
            <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('ai-pov')} data-id="element-2167">
              <div className="flex items-center" data-id="element-2168">
                <BrainIcon className="h-3.5 w-3.5 text-purple-600 mr-1.5" data-id="element-2169" />
                <h3 className="text-xs font-semibold text-gray-800" data-id="element-2170">AI POV</h3>
              </div>
              {expanded.includes('ai-pov') ? <ChevronDownIcon className="h-3 w-3 text-gray-500" data-id="element-2171" /> : <ChevronRightIcon className="h-3 w-3 text-gray-500" data-id="element-2172" />}
            </div>
            {expanded.includes('ai-pov') && <div className="bg-purple-50 rounded-md p-2.5 text-xs border border-purple-100" data-id="element-2173">
                <div className="flex items-start mb-2" data-id="element-2174">
                  <HeartHandshakeIcon className="h-3.5 w-3.5 text-purple-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2175" />
                  <span className="font-medium text-purple-800" data-id="element-2176">
                    First-time engagement with Nexus Technologies
                  </span>
                </div>
                <p className="text-gray-700 mb-2" data-id="element-2177">
                  This is your first call with Nexus Technologies, a mid-size
                  SaaS company focusing on data integration solutions. Their
                  team is exploring options to improve their meeting preparation
                  workflows and sales enablement processes.
                </p>
                <div className="bg-white rounded p-2 mb-2 border border-purple-100" data-id="element-2178">
                  <div className="flex items-start mb-1.5" data-id="element-2179">
                    <StarIcon className="h-3 w-3 text-purple-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2180" />
                    <span className="font-medium text-purple-800" data-id="element-2181">
                      Product Fit Analysis: 87% Match
                    </span>
                  </div>
                  <p className="text-gray-700 text-xs" data-id="element-2182">
                    Nexus Technologies' needs align strongly with our meeting
                    preparation platform. Their sales team (led by Brad
                    Blackwell) is looking to reduce prep time and improve client
                    intelligence, while their product team (Teena Reale, Edwin
                    Lee) wants better integration capabilities for their
                    existing workflow tools.
                  </p>
                </div>
                <div className="space-y-1.5" data-id="element-2183">
                  <div className="flex items-start" data-id="element-2184">
                    <CheckCircleIcon className="h-3 w-3 text-green-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2185" />
                    <p className="text-gray-700" data-id="element-2186">
                      <span className="font-medium" data-id="element-2187">Key opportunity:</span>{' '}
                      Calendar integration with their existing Salesforce
                      instance
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-2188">
                    <CheckCircleIcon className="h-3 w-3 text-green-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2189" />
                    <p className="text-gray-700" data-id="element-2190">
                      <span className="font-medium" data-id="element-2191">Pain point:</span> Their
                      team spends 5+ hours weekly on manual meeting research
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-2192">
                    <AlertTriangleIcon className="h-3 w-3 text-amber-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2193" />
                    <p className="text-gray-700" data-id="element-2194">
                      <span className="font-medium" data-id="element-2195">Potential objection:</span>{' '}
                      Security concerns around calendar access
                    </p>
                  </div>
                </div>
              </div>}
          </div>

          {/* Meeting Info */}
          <div className="mb-3" data-id="element-2196">
            <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('meeting-info')} data-id="element-2197">
              <div className="flex items-center" data-id="element-2198">
                <CalendarIcon className="h-3.5 w-3.5 text-blue-600 mr-1.5" data-id="element-2199" />
                <h3 className="text-xs font-semibold text-gray-800" data-id="element-2200">
                  Meeting Info
                </h3>
              </div>
              {expanded.includes('meeting-info') ? <ChevronDownIcon className="h-3 w-3 text-gray-500" data-id="element-2201" /> : <ChevronRightIcon className="h-3 w-3 text-gray-500" data-id="element-2202" />}
            </div>
            {expanded.includes('meeting-info') && <div className="bg-gray-50 rounded-md p-2 text-xs" data-id="element-2203">
                <h4 className="font-medium" data-id="element-2204">PM and Sales Project Review</h4>
                <div className="mt-1 text-gray-600 space-y-1" data-id="element-2205">
                  <div className="flex items-start" data-id="element-2206">
                    <ClockIcon className="h-3 w-3 text-gray-500 mt-0.5 mr-1.5" data-id="element-2207" />
                    <span data-id="element-2208">Thursday, August 21 • 1:30 - 2:30pm</span>
                  </div>
                  <div className="flex items-start" data-id="element-2209">
                    <UsersIcon className="h-3 w-3 text-gray-500 mt-0.5 mr-1.5" data-id="element-2210" />
                    <span data-id="element-2211">10 attendees (5 yes, 1 no, 1 maybe, 3 awaiting)</span>
                  </div>
                  <div className="flex items-start" data-id="element-2212">
                    <MapPinIcon className="h-3 w-3 text-gray-500 mt-0.5 mr-1.5" data-id="element-2213" />
                    <span data-id="element-2214">Google Meet</span>
                  </div>
                  <div className="flex items-start" data-id="element-2215">
                    <FileTextIcon className="h-3 w-3 text-gray-500 mt-0.5 mr-1.5" data-id="element-2216" />
                    <span data-id="element-2217">
                      <span className="font-medium" data-id="element-2218">Agenda:</span> Product
                      overview, integration capabilities, pricing discussion,
                      and next steps
                    </span>
                  </div>
                </div>
              </div>}
          </div>

          {/* Attendees Section */}
          <div className="mb-3" data-id="element-2219">
            <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('attendees')} data-id="element-2220">
              <div className="flex items-center" data-id="element-2221">
                <UsersIcon className="h-3.5 w-3.5 text-blue-600 mr-1.5" data-id="element-2222" />
                <h3 className="text-xs font-semibold text-gray-800" data-id="element-2223">
                  Attendees
                </h3>
              </div>
              <div className="flex items-center" data-id="element-2224">
                <span className="text-xs text-gray-500 mr-2" data-id="element-2225">
                  10 participants
                </span>
                {expanded.includes('attendees') ? <ChevronDownIcon className="h-3 w-3 text-gray-500" data-id="element-2226" /> : <ChevronRightIcon className="h-3 w-3 text-gray-500" data-id="element-2227" />}
              </div>
            </div>
            {expanded.includes('attendees') && <div className="space-y-2" data-id="element-2228">
                {attendees.slice(0, 5).map(attendee => <div key={attendee.id} className="bg-gray-50 rounded-md overflow-hidden" data-id="element-2229">
                    <div className="flex items-center justify-between p-2 cursor-pointer hover:bg-gray-100" onClick={() => toggleContact(attendee.id)} data-id="element-2230">
                      <div className="flex items-center" data-id="element-2231">
                        <div className={`h-6 w-6 rounded-full ${attendee.researched ? 'bg-blue-500' : 'bg-gray-400'} flex items-center justify-center text-white text-xs font-medium`} data-id="element-2232">
                          {attendee.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div className="ml-2" data-id="element-2233">
                          <div className="text-xs font-medium" data-id="element-2234">
                            {attendee.name}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-2235">
                            {attendee.role}, {attendee.company}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2" data-id="element-2236">
                        <span className={`text-xs px-1.5 py-0.5 rounded-full ${attendee.status === 'Going' ? 'bg-green-100 text-green-800' : attendee.status === 'Not Going' ? 'bg-red-100 text-red-800' : attendee.status === 'Maybe' ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-2237">
                          {attendee.status}
                        </span>
                        {expandedContacts.includes(attendee.id) ? <ChevronDownIcon className="h-3 w-3 text-gray-500" data-id="element-2238" /> : <ChevronRightIcon className="h-3 w-3 text-gray-500" data-id="element-2239" />}
                      </div>
                    </div>
                    {expandedContacts.includes(attendee.id) && <div className="border-t border-gray-200 p-2 bg-white" data-id="element-2240">
                        <div className="grid grid-cols-2 gap-2 mb-2" data-id="element-2241">
                          <div className="flex items-start" data-id="element-2242">
                            <MailIcon className="h-3 w-3 text-gray-500 mt-0.5 mr-1.5" data-id="element-2243" />
                            <span className="text-xs" data-id="element-2244">{attendee.email}</span>
                          </div>
                          {attendee.phone && <div className="flex items-start" data-id="element-2245">
                              <PhoneIcon className="h-3 w-3 text-gray-500 mt-0.5 mr-1.5" data-id="element-2246" />
                              <span className="text-xs" data-id="element-2247">{attendee.phone}</span>
                            </div>}
                        </div>
                        {attendee.bio && <div className="mb-2" data-id="element-2248">
                            <div className="text-xs text-gray-500 mb-1" data-id="element-2249">
                              Bio
                            </div>
                            <p className="text-xs" data-id="element-2250">{attendee.bio}</p>
                          </div>}
                        {attendee.notes && <div className="mb-2" data-id="element-2251">
                            <div className="text-xs text-gray-500 mb-1" data-id="element-2252">
                              Notes
                            </div>
                            <p className="text-xs" data-id="element-2253">{attendee.notes}</p>
                          </div>}
                        <div className="flex justify-between mt-2" data-id="element-2254">
                          <a href={`https://${attendee.linkedin}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 text-xs flex items-center" data-id="element-2255">
                            LinkedIn Profile
                            <ExternalLinkIcon className="h-3 w-3 ml-1" data-id="element-2256" />
                          </a>
                          <button className="text-blue-600 text-xs" data-id="element-2257">
                            Full Research
                          </button>
                        </div>
                      </div>}
                  </div>)}
                {attendees.length > 5 && <button className="text-blue-600 text-xs flex items-center" data-id="element-2258">
                    View all 10 attendees
                    <ChevronRightIcon className="h-3 w-3 ml-1" data-id="element-2259" />
                  </button>}
              </div>}
          </div>

          {/* Business Insights */}
          <div className="mb-3" data-id="element-2260">
            <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('business-insights')} data-id="element-2261">
              <div className="flex items-center" data-id="element-2262">
                <BarChart3Icon className="h-3.5 w-3.5 text-blue-600 mr-1.5" data-id="element-2263" />
                <h3 className="text-xs font-semibold text-gray-800" data-id="element-2264">
                  Business Insights
                </h3>
              </div>
              {expanded.includes('business-insights') ? <ChevronDownIcon className="h-3 w-3 text-gray-500" data-id="element-2265" /> : <ChevronRightIcon className="h-3 w-3 text-gray-500" data-id="element-2266" />}
            </div>
            {expanded.includes('business-insights') && <div className="bg-gray-50 rounded-md p-2 space-y-3" data-id="element-2267">
                <div className="grid grid-cols-2 gap-2" data-id="element-2268">
                  <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2269">
                    <div className="flex items-center mb-1.5" data-id="element-2270">
                      <BuildingIcon className="h-3 w-3 text-blue-600 mr-1.5" data-id="element-2271" />
                      <span className="text-xs font-medium" data-id="element-2272">
                        Company Overview
                      </span>
                    </div>
                    <div className="space-y-1" data-id="element-2273">
                      <div className="flex justify-between" data-id="element-2274">
                        <span className="text-xs text-gray-500" data-id="element-2275">Founded</span>
                        <span className="text-xs" data-id="element-2276">2014</span>
                      </div>
                      <div className="flex justify-between" data-id="element-2277">
                        <span className="text-xs text-gray-500" data-id="element-2278">Employees</span>
                        <span className="text-xs" data-id="element-2279">250-500</span>
                      </div>
                      <div className="flex justify-between" data-id="element-2280">
                        <span className="text-xs text-gray-500" data-id="element-2281">Industry</span>
                        <span className="text-xs" data-id="element-2282">Enterprise Software</span>
                      </div>
                      <div className="flex justify-between" data-id="element-2283">
                        <span className="text-xs text-gray-500" data-id="element-2284">Funding</span>
                        <span className="text-xs" data-id="element-2285">Series C ($45M)</span>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2286">
                    <div className="flex items-center mb-1.5" data-id="element-2287">
                      <TrendingUpIcon className="h-3 w-3 text-blue-600 mr-1.5" data-id="element-2288" />
                      <span className="text-xs font-medium" data-id="element-2289">
                        Growth Metrics
                      </span>
                    </div>
                    <div className="space-y-1" data-id="element-2290">
                      <div className="flex justify-between items-center" data-id="element-2291">
                        <span className="text-xs text-gray-500" data-id="element-2292">
                          YoY Growth
                        </span>
                        <div className="flex items-center" data-id="element-2293">
                          <span className="text-xs text-green-600 font-medium" data-id="element-2294">
                            +27%
                          </span>
                          <TrendingUpIcon className="h-2.5 w-2.5 text-green-600 ml-0.5" data-id="element-2295" />
                        </div>
                      </div>
                      <div className="flex justify-between" data-id="element-2296">
                        <span className="text-xs text-gray-500" data-id="element-2297">
                          New Customers
                        </span>
                        <span className="text-xs" data-id="element-2298">+42 (Q2 2023)</span>
                      </div>
                      <div className="flex justify-between" data-id="element-2299">
                        <span className="text-xs text-gray-500" data-id="element-2300">
                          Churn Rate
                        </span>
                        <span className="text-xs" data-id="element-2301">3.2%</span>
                      </div>
                      <div className="flex justify-between" data-id="element-2302">
                        <span className="text-xs text-gray-500" data-id="element-2303">ARR</span>
                        <span className="text-xs" data-id="element-2304">$28M (est.)</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2305">
                  <div className="flex items-center mb-1.5" data-id="element-2306">
                    <GlobeIcon className="h-3 w-3 text-blue-600 mr-1.5" data-id="element-2307" />
                    <span className="text-xs font-medium" data-id="element-2308">Market Position</span>
                  </div>
                  <div className="mb-2" data-id="element-2309">
                    <p className="text-xs" data-id="element-2310">
                      Nexus Technologies is a growing player in the data
                      integration space, competing with larger platforms like
                      MuleSoft and Boomi while targeting mid-market enterprises.
                    </p>
                  </div>
                  <div className="grid grid-cols-2 gap-2" data-id="element-2311">
                    <div data-id="element-2312">
                      <div className="text-xs text-gray-500 mb-1" data-id="element-2313">
                        Market Share
                      </div>
                      <div className="flex items-center" data-id="element-2314">
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-2315">
                          <div className="bg-blue-600 h-1.5 rounded-full" style={{
                        width: '8%'
                      }} data-id="element-2316"></div>
                        </div>
                        <span className="text-xs" data-id="element-2317">8%</span>
                      </div>
                    </div>
                    <div data-id="element-2318">
                      <div className="text-xs text-gray-500 mb-1" data-id="element-2319">
                        Competitive Position
                      </div>
                      <div className="flex items-center" data-id="element-2320">
                        <div className="w-full bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-2321">
                          <div className="bg-blue-600 h-1.5 rounded-full" style={{
                        width: '62%'
                      }} data-id="element-2322"></div>
                        </div>
                        <span className="text-xs" data-id="element-2323">62%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2324">
                  <div className="flex items-center mb-1.5" data-id="element-2325">
                    <PieChartIcon className="h-3 w-3 text-blue-600 mr-1.5" data-id="element-2326" />
                    <span className="text-xs font-medium" data-id="element-2327">
                      Technology Stack
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-1.5" data-id="element-2328">
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2329">
                      Salesforce
                    </span>
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2330">
                      AWS
                    </span>
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2331">
                      React
                    </span>
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2332">
                      Node.js
                    </span>
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2333">
                      PostgreSQL
                    </span>
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2334">
                      Slack
                    </span>
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2335">
                      Microsoft 365
                    </span>
                    <span className="text-xs bg-gray-100 px-1.5 py-0.5 rounded" data-id="element-2336">
                      Jira
                    </span>
                  </div>
                </div>
                <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2337">
                  <div className="flex items-center mb-1.5" data-id="element-2338">
                    <CircleDollarSignIcon className="h-3 w-3 text-blue-600 mr-1.5" data-id="element-2339" />
                    <span className="text-xs font-medium" data-id="element-2340">
                      Budget & Decision Process
                    </span>
                  </div>
                  <div className="space-y-1.5" data-id="element-2341">
                    <div className="flex items-start" data-id="element-2342">
                      <CheckCircleIcon className="h-3 w-3 text-green-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2343" />
                      <p className="text-xs" data-id="element-2344">
                        <span className="font-medium" data-id="element-2345">Estimated Budget:</span>{' '}
                        $50K-75K for productivity tools
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-2346">
                      <CheckCircleIcon className="h-3 w-3 text-green-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2347" />
                      <p className="text-xs" data-id="element-2348">
                        <span className="font-medium" data-id="element-2349">Decision Timeline:</span>{' '}
                        Q3 purchasing window (next 6-8 weeks)
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-2350">
                      <CheckCircleIcon className="h-3 w-3 text-green-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2351" />
                      <p className="text-xs" data-id="element-2352">
                        <span className="font-medium" data-id="element-2353">
                          Key Decision Makers:
                        </span>{' '}
                        Teena Reale (VP Product), Michael Clutterbuck (CTO)
                      </p>
                    </div>
                  </div>
                </div>
                <button className="w-full bg-blue-500 hover:bg-blue-600 text-white text-xs font-medium py-1.5 px-3 rounded-md transition-colors" data-id="element-2354">
                  View Complete Business Analysis
                </button>
              </div>}
          </div>

          {/* Previous Engagement */}
          <div className="mb-3" data-id="element-2355">
            <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('previous-engagement')} data-id="element-2356">
              <div className="flex items-center" data-id="element-2357">
                <MailIcon className="h-3.5 w-3.5 text-blue-600 mr-1.5" data-id="element-2358" />
                <h3 className="text-xs font-semibold text-gray-800" data-id="element-2359">
                  Previous Engagement
                </h3>
              </div>
              {expanded.includes('previous-engagement') ? <ChevronDownIcon className="h-3 w-3 text-gray-500" data-id="element-2360" /> : <ChevronRightIcon className="h-3 w-3 text-gray-500" data-id="element-2361" />}
            </div>
            {expanded.includes('previous-engagement') && <div className="bg-gray-50 rounded-md p-2 space-y-2" data-id="element-2362">
                <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2363">
                  <div className="flex items-start" data-id="element-2364">
                    <MailIcon className="h-3.5 w-3.5 text-blue-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2365" />
                    <div data-id="element-2366">
                      <div className="flex items-center justify-between mb-1" data-id="element-2367">
                        <div className="flex items-center" data-id="element-2368">
                          <span className="text-xs font-medium" data-id="element-2369">
                            Initial Outreach from Teena Reale
                          </span>
                          <span className="mx-1.5 text-gray-300" data-id="element-2370">•</span>
                          <span className="text-xs text-gray-500" data-id="element-2371">
                            2 weeks ago
                          </span>
                        </div>
                      </div>
                      <p className="text-xs text-gray-700 mb-1" data-id="element-2372">
                        Teena expressed interest in our meeting preparation
                        platform after seeing our product demo at the SaasTech
                        Conference. She mentioned their team spends too much
                        time researching before client meetings and is looking
                        for an AI-powered solution.
                      </p>
                      <div className="flex items-center text-xs text-gray-500" data-id="element-2373">
                        <span data-id="element-2374">Key topics: </span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2375">
                          AI capabilities
                        </span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2376">
                          Time savings
                        </span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2377">
                          Salesforce integration
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2378">
                  <div className="flex items-start" data-id="element-2379">
                    <MailIcon className="h-3.5 w-3.5 text-blue-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2380" />
                    <div data-id="element-2381">
                      <div className="flex items-center justify-between mb-1" data-id="element-2382">
                        <div className="flex items-center" data-id="element-2383">
                          <span className="text-xs font-medium" data-id="element-2384">
                            Follow-up with Brad Blackwell
                          </span>
                          <span className="mx-1.5 text-gray-300" data-id="element-2385">•</span>
                          <span className="text-xs text-gray-500" data-id="element-2386">
                            1 week ago
                          </span>
                        </div>
                      </div>
                      <p className="text-xs text-gray-700 mb-1" data-id="element-2387">
                        Brad inquired about pricing models and implementation
                        timeline. He shared that their sales team of 35 people
                        currently spends 5+ hours per week on meeting
                        preparation, and they're looking to reduce that by at
                        least 70%.
                      </p>
                      <div className="flex items-center text-xs text-gray-500" data-id="element-2388">
                        <span data-id="element-2389">Key topics: </span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2390">Pricing</span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2391">
                          Implementation
                        </span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2392">
                          ROI calculation
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-2 rounded border border-gray-200" data-id="element-2393">
                  <div className="flex items-start" data-id="element-2394">
                    <MailIcon className="h-3.5 w-3.5 text-blue-600 mt-0.5 mr-1.5 flex-shrink-0" data-id="element-2395" />
                    <div data-id="element-2396">
                      <div className="flex items-center justify-between mb-1" data-id="element-2397">
                        <div className="flex items-center" data-id="element-2398">
                          <span className="text-xs font-medium" data-id="element-2399">
                            Technical Questions from Edwin Lee
                          </span>
                          <span className="mx-1.5 text-gray-300" data-id="element-2400">•</span>
                          <span className="text-xs text-gray-500" data-id="element-2401">
                            3 days ago
                          </span>
                        </div>
                      </div>
                      <p className="text-xs text-gray-700 mb-1" data-id="element-2402">
                        Edwin sent a list of technical questions regarding API
                        capabilities, data security, and Google Calendar
                        integration. He mentioned they're evaluating three
                        solutions and will make a decision within the next
                        month.
                      </p>
                      <div className="flex items-center text-xs text-gray-500" data-id="element-2403">
                        <span data-id="element-2404">Key topics: </span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2405">API access</span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2406">Security</span>
                        <span className="mx-1.5 text-blue-600" data-id="element-2407">
                          Calendar integration
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <button className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 text-xs font-medium py-1.5 px-3 rounded-md transition-colors" data-id="element-2408">
                  View All Communication History
                </button>
              </div>}
          </div>

          {/* Quick Actions */}
          <div className="mb-3" data-id="element-2409">
            <div className="flex items-center justify-between cursor-pointer mb-2" onClick={() => toggleSection('actions')} data-id="element-2410">
              <div className="flex items-center" data-id="element-2411">
                <BriefcaseIcon className="h-3.5 w-3.5 text-blue-600 mr-1.5" data-id="element-2412" />
                <h3 className="text-xs font-semibold text-gray-800" data-id="element-2413">
                  Quick Actions
                </h3>
              </div>
              {expanded.includes('actions') ? <ChevronDownIcon className="h-3 w-3 text-gray-500" data-id="element-2414" /> : <ChevronRightIcon className="h-3 w-3 text-gray-500" data-id="element-2415" />}
            </div>
            {expanded.includes('actions') && <div className="grid grid-cols-2 gap-2" data-id="element-2416">
                <button className="bg-gray-50 hover:bg-gray-100 rounded-md p-2 flex flex-col items-center justify-center transition-colors" data-id="element-2417">
                  <FileTextIcon className="h-4 w-4 text-gray-600 mb-1" data-id="element-2418" />
                  <span className="text-xs" data-id="element-2419">Generate Brief</span>
                </button>
                <button className="bg-gray-50 hover:bg-gray-100 rounded-md p-2 flex flex-col items-center justify-center transition-colors" data-id="element-2420">
                  <UsersIcon className="h-4 w-4 text-gray-600 mb-1" data-id="element-2421" />
                  <span className="text-xs" data-id="element-2422">Research Attendees</span>
                </button>
                <button className="bg-gray-50 hover:bg-gray-100 rounded-md p-2 flex flex-col items-center justify-center transition-colors" data-id="element-2423">
                  <LineChartIcon className="h-4 w-4 text-gray-600 mb-1" data-id="element-2424" />
                  <span className="text-xs" data-id="element-2425">Business Insights</span>
                </button>
                <button className="bg-gray-50 hover:bg-gray-100 rounded-md p-2 flex flex-col items-center justify-center transition-colors" data-id="element-2426">
                  <PlusIcon className="h-4 w-4 text-gray-600 mb-1" data-id="element-2427" />
                  <span className="text-xs" data-id="element-2428">Add Notes</span>
                </button>
              </div>}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="p-3 border-t border-gray-200" data-id="element-2429">
        <button className="w-full bg-blue-500 hover:bg-blue-600 text-white text-xs font-medium py-2 px-4 rounded-md transition-colors flex items-center justify-center" data-id="element-2430">
          <span data-id="element-2431">View Full Preparation</span>
          <ExternalLinkIcon className="h-3 w-3 ml-1" data-id="element-2432" />
        </button>
      </div>
    </div>;
}